import React, { Fragment } from "react";
import { Breadcrumbs } from "../../../AbstractElements";
import { Placeholders, UIKits } from "../../../Constants/Constants";
import { Container, Row } from "reactstrap";
import PlaceholderCards from "./PlaceholderCards";
import WidthAndSizing from "./WidthAndSizing";
import Animation from "./Animation";
import CustomAnimationPlaceholder from "./CustomAnimationPlaceholder";
import Colors from "./Colors";

const PlaceholdersContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={Placeholders} parent={UIKits} />
      <Container fluid>
        <Row>
          <PlaceholderCards />
          <WidthAndSizing />
          <Animation />
          <CustomAnimationPlaceholder />
          <Colors />
        </Row>
      </Container>
    </Fragment>
  );
};

export default PlaceholdersContainer;
